import React from 'react';
import { observer } from 'mobx-react-lite';
import { getEffectiveYears } from 'global/utils/getEffectiveYears';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { PRODUCT_TEMPLATES_FILTERS } from '../../constants';

export const EffectiveYearFilterDropdown: React.FC = observer(() => {
  const {
    paginationDelegate: { filters, setFilterValue },
  } = useRFQProductTemplatesStore();

  const effectiveYearOptions = getEffectiveYears();
  const selectedLabel = effectiveYearOptions.find((opt) => opt.value === filters.effectiveYear)?.label || '';

  const onApplyFilter = (value: string | null): void => {
    if (value) {
      setFilterValue('effectiveYear', value);
    }
  };

  return (
    <FilterDropdown
      filterName="Effective Year"
      $minWidth="25rem"
      optionsWidth="25rem"
      selectedFilterLabel={selectedLabel}
      filtersList={effectiveYearOptions}
      applyFilter={onApplyFilter}
      data-test-id={PRODUCT_TEMPLATES_FILTERS.EFFECTIVE_YEAR_FILTER_DROPDOWN_TEST_ID}
    />
  );
});
